import { render, staticRenderFns } from "./HxeChangguanList.vue?vue&type=template&id=11513d2b&scoped=true"
import script from "./HxeChangguanList.vue?vue&type=script&lang=js"
export * from "./HxeChangguanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11513d2b",
  null
  
)

export default component.exports